import { PayerMixChart } from '../chart/payer-mix-chart';
import _ from 'lodash';
import { inject, observer } from 'mobx-react';
import React from 'react';
import { Link } from 'react-router-dom';
import { IInjectedRootStore } from '../../stores';
import * as S from './payer-mix-card.styles';

interface IPayerMixCardProps {
    children?: React.ReactNode;
}

@inject('rootStore')
@observer
export class PayerMixCard extends React.Component<IPayerMixCardProps> {
    public render(): React.ReactElement {
        return (
            <S.PayerMixCard
                size="medium"
                title="Payer Mix"
                info={this.renderInfo()}
                Caption={this.renderCaption()}
                Options={this.renderOptions()}
                Link={this.renderLink()}>
                {this.renderChildren()}
            </S.PayerMixCard>
        );
    }
    private get injected(): IInjectedRootStore {
        return this.props as IPayerMixCardProps & IInjectedRootStore;
    }
    private get payerCount(): number {
        const { payerMixChart } = this.injected.rootStore.metricsStore;
        if (payerMixChart && !_.isError(payerMixChart)) {
            // payers includes "totals" tree element
            return Math.max(0, _.size(payerMixChart.payers) - 1);
        }
        return 0;
    }
    private readonly exportData = (format: string): (() => void) => {
        return (): void => {
            window.alert(`TODO: Export Payer Mix data as ${format}`);
        };
    };
    private readonly renderInfo = (): React.ReactElement => {
        return (
            <span>
                Stay up to speed on payer mix so that you can optimize your collection efforts. Gain insights on your
                largest payers to improve payer relations.
            </span>
        );
    };
    private readonly renderCaption = (): React.ReactElement => {
        return <span>Showing top {this.payerCount} in payers</span>;
    };
    private readonly renderOptions = (): React.ReactElement | undefined => {
        return undefined;
    };
    private readonly renderLink = (): React.ReactElement => {
        return <Link to="/reports">Payer Mix Report</Link>;
    };
    private readonly renderChildren = (): React.ReactElement => {
        const { dateRangeStore, metricsStore } = this.injected.rootStore;
        const [startDate, endDate] = dateRangeStore.dateRange;
        if (_.isError(metricsStore.payerMixChart)) {
            return <S.Message>No data is currently available.</S.Message>;
        } else {
            return (
                <PayerMixChart startDate={startDate} endDate={endDate} claimTypes={metricsStore.selectedClaimTypes} />
            );
        }
    };
}
